<template>
  <div v-if="option">
    <md-field class="option-text">
      <md-input
        v-model="option.selected_value"
        md-dense
        @input="optionChanged"
      />
    </md-field>
  </div>
  <div v-else>
    <p>No Option</p>
  </div>
</template>

<script>
export default {
  name: "ExtraOptionText",

  props: ["option"],

  computed: {
    optionValues() {
      return this.option.option.values.split("|");
    }
  },

  data() {
    return {
      selectedValue: ""
    };
  },

  methods: {
    optionChanged(el) {
      this.$emit("optionChanged");
    }
  }
};
</script>

<style lang="scss" scoped>
.option-text {
  margin-top: 0px;
}
</style>
